import _ from 'underscore';

import Coordinate from 'common/types/Coordinate';
import {naturalSort, omitNull} from 'common/utils';


export default class Address {
  /* eslint-disable camelcase */
  constructor({
    address,
    address_id,
    name,
    position,
  }) {
    this.address = address || '';
    this.addressId = address_id || null;
    this.name = name || '';
    this.position = position ? new Coordinate(position.latitude, position.longitude) : null;
  }
  /* eslint-enable camelcase */

  clone() {
    return new Address(this.serialize());
  }

  compare(other) {
    return naturalSort.compare(this.name, other.name);
  }

  serialize() {
    return omitNull({
      address: this.address,
      address_id: this.addressId,
      name: this.name,
      position: this.position ? {latitude: this.position.lat, longitude: this.position.lng} : null,
    });
  }

  isDifferent(other) {
    return !_.isEqual(this.serialize(), other.serialize());
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/types/Address.js